import React, { useRef, useState } from "react"

import 'firebase/compat/firestore';
import { firestore } from "../firebase/firebase";
import { collection, serverTimestamp, addDoc} from "@firebase/firestore";

import { Link } from "react-router-dom";


import {TextField, Button, Input } from "@mui/material";
import {  Card, Row, Col, Form} from "react-bootstrap";


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../organisation/footer/Footer";
toast.configure();


const Contact = () => {


    const [success, setSuccess] = useState(null);

    const emailRef = useRef();
    const messageRef = useRef();
  
    const AlertDismissable = () => {
  
      if (success === true) {
        
        return (
          <div>
            <h6 style={{ color: 'white' }}>
              {`Signed up, thanks!`}
            </h6>
  
          </div>
            
            
        );
  
      } else if (success === false) {
  
        return (
            <h6 style={{color: 'red'}}>Opps, something went wrong!</h6>
        );
  
      } else {
  
        return null;
  
      };
    
    };
  
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
  
        const listRef = collection(firestore, `forms`)
  
        await addDoc( listRef, {
          createdAt: serverTimestamp(),
          email: emailRef.current.value,
          message: messageRef.current.value
          
        });
        
      } catch (error) {
  
        console.log(error.message);
        setSuccess(false);
        
      } finally {
  
        toast("Thanks for hanging around!")
        setSuccess(true);
  
      };
  
    };

  return (

    <div>
    <div style={{ overflow: 'hidden', backgroundColor: '#141332', color: 'white', padding: '3%' }}>
      <center>
    <Row>
            <Col>
              <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
            </Col>
            <Col style={{textAlign: 'right'}}>
            <Link to="/levels"><Button
                    sx={{ mt: 1, mr: 1 }}
                    style={{borderColor:'white', color: 'white', marginLeft: '20px'}}
                    variant="outlined"
                  >
                    Dashboard
            </Button></Link>
            <Link to="/languages"><Button
                    variant="contained"
                    sx={{ mt: 1, mr: 1 }}
                    style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #428BC1)', color: 'white', marginLeft: '40px'}}
            >Get started</Button></Link>
            </Col>
          </Row>
      <h6 style={{paddingTop: '5%'}}>Feel free to drop us some constructive critisim; notify us of any bugs and/or simply send us your love for the platform!</h6>
      <br/>
      <Card style={{maxWidth: '60%', padding: '10%', backgroundColor: '#1D1D41'}}>
        <Card.Body>
        <Form onSubmit={handleSubmit} >
          <h6 style={{color: 'white'}}>Email:</h6>
            <Input style= {{backgroundColor: 'white', padding: '10px', borderRadius: '5px'}} type="email"  ref={emailRef}  placeholder="Enter your email" required/><br/><br/>
            <h6 style={{color: 'white'}}>Message:</h6>
            <TextField
          style= {{backgroundColor: 'white', padding: '10px', borderRadius: '5px'}} type="textarea"  
          placeholder="Message" 
          required
          multiline
          ref={messageRef}
          /><br/><br/>
            <Button type="submit" style={{backgroundImage: 'linear-gradient(to left, #ED4CDD, #5208F0)', color: "white"}} size="lg">
              Submit
            </Button>
          </Form>
          {AlertDismissable()}
        </Card.Body>
      </Card>
      </center>
    </div>
    <Footer/>  
  </div>
  );

};

export default Contact;